import BpkCard from '@skyscanner/backpack-web/bpk-component-card';
import {
  withLazyLoading,
  withLoadingBehavior,
} from '@skyscanner/backpack-web/bpk-component-image';
import BpkText, {
  TEXT_COLORS,
} from '@skyscanner/backpack-web/bpk-component-text';

import BackgroundImage from '../BackgroundImage';
import DirectFlightLabel from '../DirectFlightLabel';
import QuoteLink from '../QuoteLink';
import { DEFAULT_IMAGE_URL, DIRECTNESS } from '../constants';
import { buildBrowseViewLink } from '../helpers/url-builder';
import { trackSelectResult } from '../services/event-tracking';

import type { BrowseListCardProps } from '@skyscanner-internal/landing-pages-shared-types/types-shared/DestinationsExplorer';

import STYLES from './BrowseListCard.module.scss';

const PRICED = 'priced';
const UNPRICED = 'unpriced';
const AVAILABLE = 'available';
const UNAVAILABLE = 'unavailable';
const RESIZE_PARAMETERS = '?resize=500px:500px&quality=60';

const documentIfExists = typeof window !== 'undefined' ? document : null;

const clickHandler = (
  e: Event,
  browseViewLink: string,
  props: BrowseListCardProps,
) => {
  e.preventDefault();

  const {
    place: { destinationId, direct, imageUrl, price },
    position,
    query,
  } = props;

  const priced = price ? PRICED : UNPRICED;
  const directStr = DIRECTNESS[direct] || '';
  const imageAvailable =
    imageUrl === DEFAULT_IMAGE_URL ? UNAVAILABLE : AVAILABLE;

  trackSelectResult({
    ...query,
    position,
    direct: directStr.toLowerCase(),
    priced,
    imageAvailable,
    placeCode: destinationId,
  });

  window.location.href = browseViewLink;
};

const LoadedBackgroundImage = (params: any) => (
  <BackgroundImage {...params} inView loading={false} />
);

const BrowseListCard = (props: BrowseListCardProps) => {
  const {
    enableLazyLoading = true,
    place: {
      countryName,
      destinationId,
      direct,
      imageUrl,
      inboundDate,
      name,
      outboundDate,
      price,
    },
    query: { origin },
  } = props;

  const browseViewLink = buildBrowseViewLink(
    origin,
    destinationId,
    direct,
    outboundDate,
    inboundDate,
  );

  const Image = enableLazyLoading
    ? withLoadingBehavior(withLazyLoading(BackgroundImage, documentIfExists))
    : withLoadingBehavior(LoadedBackgroundImage);

  return (
    <BpkCard
      className={STYLES.BrowseListCard__card}
      padded={false}
      href={browseViewLink}
      onClick={(e: Event) => clickHandler(e, browseViewLink, props)}
      rel="nofollow"
    >
      <Image src={imageUrl + RESIZE_PARAMETERS} />
      <div className={STYLES.BrowseListCard__container}>
        <div className={STYLES.BrowseListCard__destinationName}>
          <BpkText
            color={TEXT_COLORS.textPrimary}
            className={STYLES.DestinationTitle}
          >
            {name}
          </BpkText>
          {countryName && (
            <BpkText
              color={TEXT_COLORS.textSecondary}
              className={STYLES.DestinationSubtitle}
              data-testid="browse-list-card-subtitle"
            >
              {countryName}
            </BpkText>
          )}
        </div>
        <div className={STYLES.BrowseListCard__destinationInfo}>
          <DirectFlightLabel direct={direct} />
          <QuoteLink price={price} />
        </div>
      </div>
    </BpkCard>
  );
};

export default BrowseListCard;
